<!-- views/staff/addStaffList.vue -->
<template>
  <div class="add-staff-container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>{{ $t('addStaff.title') }}</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form label-width="120px">
            <el-form-item :label="$t('addStaff.staffName')">
              <el-input v-model="addStaffInfo.username" :placeholder="$t('addStaff.staffNamePlaceholder')"
                maxlength="10" show-word-limit />
            </el-form-item>
            <el-form-item :label="$t('addStaff.staffGender')">
              <el-select v-model="addStaffInfo.sex" :placeholder="$t('addStaff.staffGenderPlaceholder')"
                style="width: 100%">
                <el-option :label="$t('addStaff.male')" value="0" />
                <el-option :label="$t('addStaff.female')" value="1" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('addStaff.relCd')">
              <el-select v-model="addStaffInfo.relCd" :placeholder="$t('addStaff.relCdPlaceholder')"
                style="width: 100%">
                <el-option v-for="item in addStaffInfo.relCds" :key="item.value" :label="item.name"
                  :value="item.statusCd" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('addStaff.phone')">
              <el-input v-model="addStaffInfo.tel" :placeholder="$t('addStaff.phonePlaceholder')" maxlength="11" />
            </el-form-item>
            <el-form-item :label="$t('addStaff.photo')">
              <div class="photo-card">
                <div class="photo-preview" v-if="addStaffInfo.photoUrl === '' && hasCamera">
                  <video ref="video" autoplay playsinline class="photo-media"></video>
                  <canvas ref="canvas" style="display: none"></canvas>
                </div>
                <div class="photo-preview" v-else>
                  <img v-if="addStaffInfo.photoUrl" :src="addStaffInfo.photoUrl" class="photo-media"
                    :alt="$t('addStaff.photo')" />
                  <img v-else src="/img/noPhoto.jpg" class="photo-media" :alt="$t('addStaff.photo')" />
                </div>
                <div class="photo-actions">
                  <el-button v-show="hasCamera" type="primary" icon="el-icon-camera" size="small" @click="takePhoto">
                    {{ $t('addOwnerMember.takePhoto') }}
                  </el-button>
                  <el-button type="primary" icon="el-icon-upload2" size="small" @click="_uploadPhoto">
                    {{ $t('addOwnerMember.uploadPhoto') }}
                  </el-button>
                </div>
                <input ref="fileInput" type="file" accept=".jpg,.jpeg,.png" style="display: none"
                  @change="_choosePhoto" />
              </div>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <el-form label-width="120px">
            <el-form-item :label="$t('addStaff.email')">
              <el-input v-model="addStaffInfo.email" :placeholder="$t('addStaff.emailPlaceholder')" />
            </el-form-item>
            <el-form-item :label="$t('addStaff.address')">
              <el-input v-model="addStaffInfo.address" :placeholder="$t('addStaff.addressPlaceholder')" />
            </el-form-item>
            <el-form-item :label="$t('addStaff.relatedOrg')">
              <el-input v-model="addStaffInfo.orgName" :placeholder="$t('addStaff.relatedOrgPlaceholder')" readonly
                @focus="handleChooseOrg" />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div class="footer-buttons">
        <el-button type="primary" @click="saveStaffInfo">
          <i class="el-icon-check" /> {{ $t('addStaff.save') }}
        </el-button>
        <el-button @click="$router.go(-1)">
          {{ $t('addStaff.cancel') }}
        </el-button>
      </div>
    </el-card>
    <choose-org-tree ref="chooseOrgTree" @switchOrg="handleSwitchOrg" />
  </div>
</template>

<script>
import { addStaff, uploadFile } from '@/api/staff/addStaffApi'
import ChooseOrgTree from '@/components/org/ChooseOrgTree'
import { getDict, getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'AddStaff',
  components: {
    ChooseOrgTree
  },
  data() {
    return {
      addStaffInfo: {
        orgId: '',
        orgName: '',
        relCd: '',
        username: '',
        sex: '',
        email: '',
        tel: '',
        address: '',
        photo: '',
        photoUrl: '',
        adminFlag: 'N',
        relCds: []
      },
      stream: null,
      hasCamera: false
    }
  },
  mounted() {
    this.getRelCd()
    this.$nextTick(() => {
      this.startCamera()
    })
  },
  beforeDestroy() {
    this.stopCamera()
  },
  methods: {
    async getRelCd() {
      const data = await getDict('u_org_staff_rel', "rel_cd")
      this.addStaffInfo.relCds = data
    },
    handleChooseOrg() {
      this.$refs.chooseOrgTree.open()
    },
    handleSwitchOrg(org) {
      console.log(org)
      this.addStaffInfo.orgId = org.orgId
      this.addStaffInfo.orgName = org.allOrgName
    },
    validateForm() {
      if (!this.addStaffInfo.username || this.addStaffInfo.username.length < 2 || this.addStaffInfo.username.length > 10) {
        this.$message.error(this.$t('addStaff.staffNamePlaceholder'))
        return false
      }
      if (!this.addStaffInfo.sex) {
        this.$message.error(this.$t('addStaff.staffGenderPlaceholder'))
        return false
      }
      if (!this.addStaffInfo.tel || !/^1[3-9]\d{9}$/.test(this.addStaffInfo.tel)) {
        this.$message.error(this.$t('addStaff.phonePlaceholder'))
        return false
      }
      if (!this.addStaffInfo.address) {
        this.$message.error(this.$t('addStaff.addressPlaceholder'))
        return false
      }
      if (!this.addStaffInfo.orgId) {
        this.$message.error(this.$t('addStaff.relatedOrgPlaceholder'))
        return false
      }
      return true
    },
    async saveStaffInfo() {
      if (!this.validateForm()) return

      try {
        const data = {
          ...this.addStaffInfo,
          name: this.addStaffInfo.username
        }
        const res = await addStaff(data)
        if (res.code === 0) {
          this.$message.success('添加成功')
          this.$router.go(-1)
        } else {
          this.$message.error(res.msg || '添加失败')
        }
      } catch (error) {
        this.$message.error(error.message || '添加失败')
      }
    },
    loadImageFromBlob(blob) {
      return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(blob)
        const img = new Image()
        img.onload = () => {
          URL.revokeObjectURL(url)
          resolve(img)
        }
        img.onerror = (e) => {
          URL.revokeObjectURL(url)
          reject(e)
        }
        img.src = url
      })
    },
    canvasToJpegBlob(canvas, quality) {
      return new Promise((resolve) => {
        canvas.toBlob((blob) => resolve(blob), 'image/jpeg', quality)
      })
    },
    scaleDownCanvas(sourceCanvas, ratio) {
      const targetCanvas = document.createElement('canvas')
      targetCanvas.width = Math.max(1, Math.round(sourceCanvas.width * ratio))
      targetCanvas.height = Math.max(1, Math.round(sourceCanvas.height * ratio))
      const ctx = targetCanvas.getContext('2d')
      ctx.drawImage(sourceCanvas, 0, 0, targetCanvas.width, targetCanvas.height)
      return targetCanvas
    },
    async compressJpegFile(file, { maxBytes = 100 * 1024, maxDimension = 1080 } = {}) {
      if (!file || !(file instanceof Blob)) return file
      if (file.type === 'image/jpeg' && file.size <= maxBytes) return file

      const img = await this.loadImageFromBlob(file)

      const canvas = document.createElement('canvas')
      const iw = img.naturalWidth || img.width
      const ih = img.naturalHeight || img.height
      const scale = Math.min(maxDimension / iw, maxDimension / ih, 1)
      canvas.width = Math.max(1, Math.round(iw * scale))
      canvas.height = Math.max(1, Math.round(ih * scale))

      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height)

      let quality = 0.9
      let blob = await this.canvasToJpegBlob(canvas, quality)

      while (blob && blob.size > maxBytes && quality > 0.15) {
        quality = Math.max(0.15, quality - 0.1)
        blob = await this.canvasToJpegBlob(canvas, quality)
      }

      let workingCanvas = canvas
      while (blob && blob.size > maxBytes && (workingCanvas.width > 320 || workingCanvas.height > 320)) {
        workingCanvas = this.scaleDownCanvas(workingCanvas, 0.9)
        quality = Math.min(quality, 0.8)
        blob = await this.canvasToJpegBlob(workingCanvas, quality)
        while (blob && blob.size > maxBytes && quality > 0.15) {
          quality = Math.max(0.15, quality - 0.1)
          blob = await this.canvasToJpegBlob(workingCanvas, quality)
        }
      }

      const finalBlob = blob && blob.size ? blob : file
      const name = typeof file.name === 'string' && file.name ? file.name.replace(/\.[^/.]+$/, '') + '.jpg' : 'photo.jpg'
      return new File([finalBlob], name, { type: 'image/jpeg' })
    },
    async startCamera() {
      try {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          this.$message && this.$message.error('当前浏览器不支持摄像头调用')
          return
        }

        if (!navigator.mediaDevices.enumerateDevices) {
          this.$message && this.$message.warning('无法检测摄像头设备，直接尝试打开摄像头')
        } else {
          const devices = await navigator.mediaDevices.enumerateDevices()
          const hasCamera = devices.some((d) => d.kind === 'videoinput')

          if (!hasCamera) {
            this.hasCamera = false
            return
          }
        }

        this.hasCamera = true
        await this.$nextTick()

        this.stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: 'environment' },
          audio: false
        })

        const video = this.$refs.video
        if (!video) {
          console.warn('video ref 未就绪，无法挂载摄像头流')
          return
        }

        if ('srcObject' in video) {
          video.srcObject = this.stream
        } else {
          video.src = window.URL.createObjectURL(this.stream)
        }
        video.play()
      } catch (err) {
        console.error('打开摄像头失败', err)

        if (err.name === 'NotFoundError' || err.name === 'OverconstrainedError') {
          this.$message && this.$message.error('未检测到可用的摄像头')
        } else if (err.name === 'NotAllowedError' || err.name === 'SecurityError') {
          this.$message && this.$message.error('摄像头权限被拒绝，请在浏览器中开启权限')
        } else {
          this.$message && this.$message.error('打开摄像头失败，请检查设备和权限')
        }
      }
    },
    stopCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach((track) => track.stop())
        this.stream = null
      }

      const video = this.$refs.video
      if (video) {
        if ('srcObject' in video) {
          video.srcObject = null
        } else {
          video.src = ''
        }
        video.pause && video.pause()
      }
    },
    takePhoto() {
      if (this.addStaffInfo.photoUrl) {
        if (!this.hasCamera) return

        this.addStaffInfo.photo = ''
        this.addStaffInfo.photoUrl = ''

        if (this.$refs.fileInput) this.$refs.fileInput.value = ''

        this.stopCamera()
        this.$nextTick(() => this.startCamera())
        return
      }

      const video = this.$refs.video
      const canvas = this.$refs.canvas
      if (!video || !canvas) return

      const vw = video.videoWidth
      const vh = video.videoHeight
      if (!vw || !vh) {
        console.warn('无法获取视频分辨率')
        return
      }

      const maxSize = 1080
      const scale = Math.min(maxSize / vw, maxSize / vh, 1)

      const targetW = Math.round(vw * scale)
      const targetH = Math.round(vh * scale)

      canvas.width = targetW
      canvas.height = targetH

      const ctx = canvas.getContext('2d')
      ctx.drawImage(video, 0, 0, targetW, targetH)

      canvas.toBlob((blob) => {
        if (!blob) return
        const file = new File([blob], 'photo.jpg', { type: 'image/jpeg' })
        this._doUploadImage(file)
        this.stopCamera()
      }, 'image/jpeg', 0.8)
    },
    _uploadPhoto() {
      this.$refs.fileInput.click()
    },
    _choosePhoto(event) {
      const files = event.target.files
      if (files && files.length > 0) {
        const file = files[0]
        if (file.size > 1024 * 1024 * 2) {
          this.$message.error('图片大小不能超过2MB')
          event.target.value = ''
          return
        }
        this._doUploadImage(file)
        event.target.value = ''
      }
    },
    async _doUploadImage(file) {
      try {
        const compressedFile = await this.compressJpegFile(file, { maxBytes: 100 * 1024, maxDimension: 1080 })
        const formData = new FormData()
        formData.append('uploadFile', compressedFile)
        formData.append('communityId', getCommunityId())

        const res = await uploadFile(formData)
        this.addStaffInfo.photo = res.fileId
        this.addStaffInfo.photoUrl = res.url
      } catch (err) {
        console.error('上传失败:', err)
        this.$message.error(this.$t('addOwnerMember.uploadFailed'))
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.add-staff-container {
  padding: 20px;
  text-align: left;

  .footer-buttons {
    margin-top: 20px;
    text-align: right;
  }

  .el-form-item {
    margin-bottom: 22px;
  }

  .photo-card {
    width: 100%;
    max-width: 360px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }

  .photo-preview {
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .photo-media {
    width: 150px;
    height: 150px;
    object-fit: cover;
    display: block;
  }

  video.photo-media {
    width: 320px;
    height: 160px;
    max-width: 100%;
  }

  .photo-actions {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }

  .photo-actions .el-button {
    width: 120px;
    margin-left: 0;
    margin-right: 0;
  }
}
</style>
